import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsLegacyFieldLayoutRoute } from '@atlassian/jira-router-routes-admin-pages-legacy-field-layout-routes/src/globalSettingsLegacyFieldLayoutRoute.tsx';
import { LazyLegacyFieldLayoutPage, LazyLegacyFieldLayoutPromise } from './ui/spa/index.tsx';

export const globalSettingsLegacyFieldLayoutRouteEntry = createEntry(
	globalSettingsLegacyFieldLayoutRoute,

	() => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		component: LazyLegacyFieldLayoutPage,
		forPaint: [LazyLegacyFieldLayoutPromise],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-legacy-field-layout-entries/src/globalSettingsLegacyFieldLayoutRouteEntry.tsx',
				whichExportToUse: 'globalSettingsLegacyFieldLayoutRouteEntry',
			},

			enabled: true,
		},
	}),
);
